import React from 'react';
import { FileUpload } from '../services/api';
import { X, FileText, Image, FileSpreadsheet } from 'lucide-react';
import './FileDisplay.css';

interface FileDisplayProps {
  files: FileUpload[];
  onRemoveFile?: (fileId: string) => void;
}

const FileDisplay: React.FC<FileDisplayProps> = ({ files, onRemoveFile }) => {
  if (files.length === 0) {
    return null;
  }

  const getFileIcon = (fileType: string) => {
    if (fileType.includes('image')) {
      return <Image size={16} />;
    } else if (fileType.includes('spreadsheet') || fileType.includes('excel') || fileType.includes('csv')) {
      return <FileSpreadsheet size={16} />;
    } else {
      return <FileText size={16} />;
    }
  };

  const formatFileSize = (bytes: number) => {
    if (bytes < 1024) return bytes + ' B';
    else if (bytes < 1048576) return Math.round(bytes / 1024) + ' KB';
    else return Math.round(bytes / 1048576) + ' MB';
  };

  return (
    <div className="file-display-container">
      <div className="file-display-header">
        <span className="file-display-title">Attached Files ({files.length})</span>
      </div>
      <div className="file-display-list">
        {files.map((file) => (
          <div key={file.file_id} className="file-display-item">
            <div className="file-icon">
              {getFileIcon(file.file_type)}
            </div>
            <div className="file-info">
              <span className="file-name">{file.filename}</span>
              <span className="file-size">{formatFileSize(file.size_bytes)}</span>
            </div>
            {onRemoveFile && (
              <button
                className="file-remove-btn"
                onClick={() => onRemoveFile(file.file_id)}
                title="Remove file"
              >
                <X size={14} />
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FileDisplay;